import React, { useContext, useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { isEmpty, map } from 'lodash';
import i18n from 'i18n';
import useBackIf from 'hooks/useBackIf';
import { sendRestorePasswordOTP } from 'actions/profile';
import scaleSize from 'utils/scale-size';
import { RestorePasswordContext } from './RestorePasswordContext';
import Header from '../common/Header';
import ActionsSection from '../ActionsSection';
import { StyledWhiteText, StyledBlock, StyledContractList } from '../StyledComponents';

const i18nScope = 'authorizationRestorePasswordContractPage';
const SECTION_NAME = 'CONTRACT_NUMBER_INPUT';

const LIST_CONFIG = {
  enterTo: 'last-focused',
  defaultElement: '.selected',
  leaveFor: {
    up: '',
    down: '',
  },
};

const getLocationMessage = (locationState) => {
  if (!(locationState || {}).message) return '';

  const { text, loginValue } = locationState.message;
  const index = text.indexOf(loginValue);
  return [
    text.slice(0, index),
    <StyledWhiteText key="highlighted">{loginValue}</StyledWhiteText>,
    text.slice(index + loginValue.length),
  ];
};

const AuthorizationRestorePasswordContractPage = () => {
  const { location } = useHistory();
  const dispatch = useDispatch();
  const { contextState, setContextState } = useContext(RestorePasswordContext);
  const { phone, email } = contextState;
  const description = useMemo(() => getLocationMessage(location.state), [location.state]);
  const contracts = useMemo(() => {
    // id is required for VerticalList
    return map(location.state?.contracts, (contract, i) => {
      return { ...contract, id: i };
    });
  }, [location.state]);

  const onSubmit = useCallback(
    ({ contractId }) => {
      dispatch(
        sendRestorePasswordOTP({
          phone,
          email,
          contractId,
          errorModal: { returnFocusTo: `@${SECTION_NAME}` },
        }),
      );
    },
    [dispatch, email, phone],
  );

  useEffect(() => {
    setContextState((state) => ({ ...state, isSeveralContracts: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useBackIf(isEmpty(contracts));

  return (
    <>
      <Header isWideBlock={true} title={i18n.t(`${i18nScope}.title`)} description={description} />
      <StyledBlock>
        <StyledContractList
          listId={SECTION_NAME}
          sectionName={SECTION_NAME}
          items={contracts}
          itemRender={(props) => {
            const { index, item, onEnter, onFocus } = props;

            return (
              <ActionsSection.Button
                key={item.login}
                label={`${item.login}`}
                onEnter={() => onEnter(index)}
                onFocus={() => onFocus(index)}
                focusOnMouseEnter={false}
              />
            );
          }}
          startScrollIndex={2}
          itemHeight={scaleSize(104)}
          onEnter={onSubmit}
          renderSize={12}
          config={LIST_CONFIG}
          defaultSection
        />
      </StyledBlock>
    </>
  );
};

export default AuthorizationRestorePasswordContractPage;
